import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IBusinesses, IBusinessesState } from ".";

export interface IStartBusinessesResponse {
    businesses: IBusinesses[];
    businessType: number;
    balance: number,
    exp: number,
    profit: number;
}

export const startBusiness = createAsyncThunk<IStartBusinessesResponse, number>(
    'startBusiness',
    async (type: number) => await api.businesses.start(type)
);

const startBusinessesHandler = (builder: ActionReducerMapBuilder<IBusinessesState>) => {
    builder
        .addCase(startBusiness.pending, (state: IBusinessesState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(startBusiness.fulfilled, (state: IBusinessesState, action: PayloadAction<IStartBusinessesResponse>) => {
            state.loading = false;

            if (!action.payload)
                return;

            state.businesses = action.payload.businesses ?? [];

            if (state.businesses.length)
                state.activeBusiness = state.businesses.find(item => item.type === action.payload.businessType) ?? null;

            if (state.activeBusiness)
                state.activeBusiness.elements.sort((a, b) => a.type - b.type);
        })
        .addCase(startBusiness.rejected, (state: IBusinessesState) => {
            state.loading = false;
            state.error = 'Unable to start businesses';
        });
};

export default startBusinessesHandler;